import { createSelector } from 'reselect';
import State from 'types/state';

const getNotificationState = (state: State) => state.notification;

export default createSelector([getNotificationState], (state) => ({
  ...state,
}));
